import {ACTION_TYPES} from "../../../core/consts";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {CompetitionsSliderMenuClickEvent} from "../models/competitions-slider-menu.click-event";
import {MenuClickEventHandler} from "../../../core/handlers/menu.click-event.handler";

export class CompetitionsSliderMenuClickEventHandler extends MenuClickEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.menuClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = CompetitionsSliderMenuClickEvent
  }
}
